if (!customElements.get('noise-delivery-timeline')) {
  customElements.define('noise-delivery-timeline', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.variantData = this.productInfo?.querySelector('[data-selected-variant]');
      this.updateAvailability = () => {
        try {
          const variant = JSON.parse(this.variantData?.textContent || 'null');
          this.hidden = variant?.available !== true;
        } catch {
          this.hidden = true;
        }
      };
      this.updateAvailability();
      if (this.variantData) {
        this.observer = new MutationObserver(this.updateAvailability);
        this.observer.observe(this.variantData, {childList: true, characterData: true, subtree: true});
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
